<template>
  <div class="product__breadcrumb">
    <a href="/">Home</a>
    <span>&nbsp;/&nbsp;</span>
    <!-- <a href="/collections/shop">Products</a>
    <span>&nbsp;/&nbsp;</span> -->
    <span v-if="data.title" class="product-title">{{ data.title }}</span>
    <span v-else class="product-title">{{ selectedVariant.airtable_title }}</span>
  </div>
  <Buybox 
    ref="buybox"
    :product="data"
    @toggle-bis-modal="toggleBisModal"
    @toggle-uc-ship-modal="toggleCxShipModal"
  />
  <BisModal 
    :product="data"
    :selectedVariant="buybox.selectedVariant"
    v-if="isBisModalOpen" 
    @toggle-bis-modal="toggleBisModal"
  />
  <UpcomingShipment
    v-if="isUpcomingShipModalOpen"
    @toggle-uc-ship-modal="toggleCxShipModal"
  />
</template>

<script setup>
  import { ref } from 'vue';
  import Buybox from "./components/buybox.vue";
  import BisModal from './components/bis-modal.vue';
  import UpcomingShipment from './components/upcoming-shipment.vue';

  const props = defineProps({
    data: {
      type: Object,
      default: () => ({})
    }
  })

  const buybox = ref(null);
  const isBisModalOpen = ref(false);
  const isUpcomingShipModalOpen = ref(false);
  const selectedVariant = ref(null);

  const toggleBisModal = (value) => {
    isBisModalOpen.value = !isBisModalOpen.value;
  }

  const toggleCxShipModal = () => {
    isUpcomingShipModalOpen.value = !isUpcomingShipModalOpen.value;
  }

  const airtableTitle = () => {
    const params = new URLSearchParams(window.location.search);
    const variantParam = params.get('variant');

    selectedVariant.value = variantParam
      ? props.data.variants.find(variant => variant.id === variantParam)
      : props.data.variants[0];
  };

  airtableTitle();
</script>